import React from "react";
import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";
import { cookieBannerFadeSpeed } from '../../config/ui';

export default class CookieBanner extends React.PureComponent {
    state = {
        isBannerFading: false,
    };

    closeBanner = () => {
        let { closeCookieBanner } = this.props;

        this.setState({isBannerFading: true});

        setTimeout(closeCookieBanner, cookieBannerFadeSpeed * 1000)
    };

    render() {
        let { isCookieBannerShow } = this.props;

        if (!isCookieBannerShow) {
            return false;
        }

        let styles = this.state.isBannerFading ? {
            transition: cookieBannerFadeSpeed + 's',
            opacity: 0,
        } : null;

        return (
            <div className={'cookie-banner'} style={styles}>
                <div className={'icon'}>
                    <img alt={'Cookie banner'} src={require('../../assets/images/cookie-banner-icon.svg')}/>
                </div>

                <div className={'text'}>
                    We use cookies to ensure the best possible experience.
                    By using our site you agree with our <NavLink className={'link'} to={'/policy'}>Cookie Policy.</NavLink>
                </div>

                <div className={'button'} onClick={this.closeBanner}>
                    Ok
                </div>
            </div>
        );
    }
}

CookieBanner.propTypes = {
    isCookieBannerShow: PropTypes.bool.isRequired,
    closeCookieBanner: PropTypes.func.isRequired,
};
